import React from 'react';

import DSpinner from '@/components/Global/DSpinner';
import CheckIcon from '@/shared/icons/CheckIcon';
import FinishLineIcon from '@/shared/icons/FinishLineIcon';
import './index.css';

const DProgressBar = ({ steps }) => {
  return (
    <div className="flex flex-col w-full">
      <div className="progress-bar-container no-scrollbar py-2">
        <div className="progress-bar-content flex items-center w-full">
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              <div className="progress-step flex items-end w-full h-10 md:h-7">
                <div className="flex flex-col items-center w-full gap-v3-xs">
                  <div
                    className={`text-xs sm:text-sm lg:text-xs text-center leading-tight text-black whitespace-nowrap px-1 ${
                      step.active
                        ? 'font-medium text-darkGreen-300'
                        : step.completed
                        ? 'font-medium text-darkGreen-300'
                        : 'text-gray-400'
                    }`}
                  >
                    {step.progress_label}
                  </div>
                  {index <= steps.length - 1 && (
                    <div className="w-full h-1 bg-gray-300">
                      {step.completed && (
                        <div className="w-full h-full bg-green-500"></div>
                      )}
                      {step.active && (
                        <div className="w-1/2 h-full bg-green-500"></div>
                      )}
                    </div>
                  )}
                </div>
                <div className="translate-y-[10px]">
                  {step.completed && index !== steps.length - 1 && (
                    <div className="w-7 h-7 bg-darkGreen-10 rounded-full flex items-center justify-center flex-shrink-0 mx-v3-xxs">
                      <CheckIcon className="w-4 h-4 text-darkGreen-300" />
                    </div>
                  )}
                  {step.active && index !== steps.length - 1 && (
                    <div className="translate-y-[8px]">
                      <DSpinner
                        width={42}
                        height={42}
                        className="text-darkGreen-300 flex-shrink-0"
                      />
                    </div>
                  )}
                  {(step.pending || step.active) &&
                    index === steps.length - 1 && (
                      <div className="w-7 h-7  rounded-full flex items-center justify-center flex-shrink-0 mx-v3-xxs">
                        <FinishLineIcon className="w-5 h-5 text-black" />
                      </div>
                    )}

                  {step.completed && index === steps.length - 1 && (
                    <div className="w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 mx-v3-xxs">
                      <CheckIcon className="w-4 h-4 text-black" />
                    </div>
                  )}

                  {step.pending && index !== steps.length - 1 && (
                    <div className="translate-y-[8px]">
                      <DSpinner
                        width={42}
                        height={42}
                        className="text-gray-400 flex-shrink-0"
                      />
                    </div>
                  )}
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DProgressBar;
